var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdownsmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".5vw",
    height: ".5vw",
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.18416L4.55665 6L9 1.30368L7.87991 0.11952L4.55665 3.6324L1.12009 7.15256e-07L0 1.18416Z",
    fill: "#EDEDEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdownsmall);
export default __webpack_public_path__ + "static/media/Arrowdownsmall.9c5351938c660f36a9d0fe4a49a4b070.svg";
export { ForwardRef as ReactComponent };